import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

const BYTES_PER_MB = 1_048_576

export type MemoryDataPoint = {
  time: string
  memory_mb: number
}

interface MemoryChartProps {
  data: MemoryDataPoint[]
}

function formatMb(value: number): string {
  return `${value.toFixed(1)}MB`
}

export function MemoryChart({ data }: MemoryChartProps): React.JSX.Element {
  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <div className="mb-4">
        <h2 className="text-sm font-medium text-text-primary">Memory Usage</h2>
        <p className="text-xs text-text-tertiary">Resident memory over the last ~5 minutes</p>
      </div>
      {data.length === 0 ? (
        <div className="flex h-[250px] items-center justify-center">
          <p className="text-sm text-text-tertiary">Collecting data...</p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-surface-3)" />
            <XAxis dataKey="time" stroke="var(--color-text-tertiary)" fontSize={11} />
            <YAxis stroke="var(--color-text-tertiary)" fontSize={11} tickFormatter={formatMb} />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-surface-0)',
                border: '1px solid var(--color-surface-3)',
                borderRadius: '8px',
                fontSize: '12px',
              }}
              formatter={(value: number) => [formatMb(value), 'Memory']}
            />
            <Area
              type="monotone"
              dataKey="memory_mb"
              stroke="var(--color-admin-500)"
              fill="var(--color-admin-100)"
              strokeWidth={2}
              name="Memory"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  )
}

export { BYTES_PER_MB }
